import React, { CSSProperties, useEffect } from "react";

import LineLoginManager from "./LineLoginManager";

import "./LoginButton.css";

type LineLoginButtonProps = {
  style?: CSSProperties;
  disabled?: boolean;
  lineLoginText?: string;
  logoSrc?: string;
  logoStyle?: CSSProperties;
  shimmer?: boolean;
  spanStyle?: CSSProperties;
  textStyle?: CSSProperties;
  onCallback?: (data: any) => void;
  onClick?: () => void;
};

const LineLoginButton = React.forwardRef((props: LineLoginButtonProps, ref: any) => {
  const lineLoginManager = new LineLoginManager();

  useEffect(() => {
    const cleanup = () => {
      lineLoginManager.openWindow?.close();
    };

    window.addEventListener("beforeunload", cleanup); // ก่อน refresh/ปิด tab
    window.addEventListener("unload", cleanup); // เมื่อปิด tab/หน้าต่าง
    window.addEventListener("pagehide", cleanup); // เมื่อซ่อนหน้า (mobile/back-forward cache)

    const handleChangeVisibility = () => {
      if (document.hidden) {
        cleanup();
      }
    };

    document.addEventListener("visibilitychange", handleChangeVisibility);

    return () => {
      cleanup();

      window.removeEventListener("beforeunload", cleanup);
      window.removeEventListener("unload", cleanup);
      window.removeEventListener("pagehide", cleanup);
      document.removeEventListener("visibilitychange", handleChangeVisibility);
    };
  }, []);

  const handleClick = () => {
    if (props.disabled) {
      return;
    }

    if (props.onCallback) {
      lineLoginManager.onCallback = props.onCallback;

      void lineLoginManager.openLogin();
    } else {
      props.onClick?.();
    }
  };

  return (
    <div
      ref={ref}
      className={`lineLoginButton ${props.shimmer && !props.disabled ? "shimmer" : ""}`}
      style={{ ...props.style }}
      onClick={handleClick}
    >
      <img style={props.logoStyle} alt="" src={props.logoSrc || ""} />
      <div style={{ display: "flex", ...props.textStyle }}>
        <span style={props.spanStyle}>{props.lineLoginText ?? "ล็อกอินด้วย LINE"}</span>
      </div>
    </div>
  );
});

LineLoginButton.displayName = "LineLoginButton";

export default LineLoginButton;
